import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDate from '@/utils/hooks/useDate';
import router from "@/router";
import store from "@/store";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import { privilegeList } from "@/@fake-db/mock-code-template/choose-privilege-list";

import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";

export default function useChoosePrivilege(props) {
  const vm = getCurrentInstance().proxy;

  const { getPrivilegeList } = privilegeCodeTemplateModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();
  const { openDefaultErrorModal, openErrorModal } = useValidationModal();

  const { resolveDateWithSeperator, resolveTime } = useDate();

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  });

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "active-icon";
      case 2:
        return "inActive-icon";
      default:
        return "Unknown";
    }
  };

  const choosePrivilegeList = reactive({
    payload: [],
  });

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const fields = [
    { key: "seq", label: "No." },
    { key: "image_url", label: "Image" },
    { key: "name_th", label: "Privilege Name" },
    { key: "type_desc", label: "Privilege Type" },
    { key: "point_ref", label: "Point" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "status", label: "status" },
    { key: "actions", label: "" },
  ];

  const fetchPrivilegeList = () => {
    loading.tableData = true;
    getPrivilegeList.payload.Page = pagination.currentPage;
    getPrivilegeList.payload.Limit = pagination.perPage;
    getPrivilegeList.payload.Filters = filters;
    getPrivilegeList.payload.Ordering = ordering.value;

    store
      .dispatch("api/apiRequest", getPrivilegeList)
      .then((response) => {
        choosePrivilegeList.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchPrivilegeList();
    },
    { deep: true }
  );

  const privilege_Id = ref(null);
  const privilegeObj = reactive({
    data: {},
  });

  const selectPrivilege = (obj) => {
    privilege_Id.value = obj.privilege_id;
    privilegeObj.data = obj;
  };

  const onSaveModalChoosePrivilege = () => {
    vm.$emit("onSave", privilegeObj.data);
    vm.$emit("onCloseModal")
  };

  onBeforeMount(() => {
    if(props.privilegeId) privilege_Id.value = props.privilegeId
    fetchPrivilegeList();
  });

  return {
    loading,
    statusOption,
    fields,
    choosePrivilegeList,
    resolveStatusLabel,
    resolveStatusClass,

    pagination,
    onPageChange,
    onFilterEntity,
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,

    onSaveModalChoosePrivilege,
    selectPrivilege,
    privilege_Id,

    resolveDateWithSeperator
  };
}
